module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_minischool.6296d075ee019e1776b88a5c863a58d3.png";